import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';

// Raw JSON from backend
export type HealthDataPointSource = {
  type: string;
  sourceId: string;
};

// Factory function
export function createHealthDataPointSource(json?: Partial<HealthDataPointSource>): HealthDataPointSource {
  return makeAutoObservable({
    type: json?.type || 'healthkit',
    sourceId: json?.sourceId ?? UUID(),
  });
}
